module.exports = __webpack_public_path__ + "static/image/history/pc/201103@3x.jpg?8a84469c";